<EIPDatePicker #datePicker [setId]="getId()" [WaterMark]="getWaterMark()" (selectedDate)="getSelectedDate($event)">
</EIPDatePicker>